import type { JournalEntry } from '@sorrem/shared';
import { useGetCharacterJournalQuery } from '@sorrem-client/ui/store';
import { useCurrentCharacterArgs } from './use-current-character-id';

const NO_ENTRIES: readonly JournalEntry[] = [];

export interface JournalState {
    /** Watched cutscenes and commissions, oldest first. */
    entries: readonly JournalEntry[];
    /** Whether `entries` is fresh from the server, not cached or still loading. */
    isLoaded: boolean;
}

/** The current character's Journal. */
export function useJournal(): JournalState {
    // Refetch on mount: a run or the Character tab may have added to it since.
    const { data, isSuccess, isFetching } = useGetCharacterJournalQuery(useCurrentCharacterArgs(), { refetchOnMountOrArgChange: true });
    return { entries: data ?? NO_ENTRIES, isLoaded: isSuccess && !isFetching };
}
